import React from "react";
import {Link} from "../../raw-components/link/link";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {LogoContainerBox} from "./boxes/logo-container/logo-container.box";
import {LogoImageBox} from "./boxes/logo-image/default-logo-icon/logo-image.box";
import {LogoVipImageBox} from "./boxes/logo-image/vip-logo-icon/vip-logo-icon.box";
import {AnyStyledComponent} from "styled-components";

export interface LogoBoxProps {
  useDarkLogo?: boolean;
  isNavigation?: boolean,
  withAnalytics?: boolean,
  onClick?: React.MouseEventHandler
}

@observer
export class LogoBox extends OrbitComponent<LogoBoxProps> {

    private _handleClick(e: React.MouseEvent) {

    if(this.props.withAnalytics) {
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", "Logo");
    }

    if(this.props.onClick) {
      this.props.onClick(e);
    }

    this.services.location.goHome();
  }

  private _getLogoImageURL() {
    if (this.props.useDarkLogo) {
      return this.services.configuration.data.generalSettings.logoURL.replace(".png", "-dark.png");
    }
    return this.services.configuration.data.generalSettings.logoURL;
  }

  private _getLogoAlt(): string {
        let configOverride = this.services.configuration.data.generalSettings.logoAltOverride;
        return configOverride ? configOverride : `${this.services.theme.themeName} logo`;
  }

  render(): React.ReactNode {
    let TheLogoImageBox: AnyStyledComponent;

    if (this.services.user.isVip) {
      TheLogoImageBox = LogoVipImageBox;
    } else {
      TheLogoImageBox = LogoImageBox;
    }

    return (
      <LogoContainerBox className="cy-logo-container">
        <Link href={this.services.location.currentUri.origin}
              // href is for SEO purposes, not necessarily to be executed by a browser
              onClick={(e) => this._handleClick(e)}>
          <TheLogoImageBox  src={this._getLogoImageURL()}
                  alt={this._getLogoAlt()}
                  className="logo cy-logo"
          />
        </Link>
      </LogoContainerBox>
    );
  }
}


